import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectColor, colorSquare, storeCanvas } from "../actions";
import { UP, DOWN, LEFT, RIGHT, POINTS } from "./config";
const COLORS = {
    lignes: "#111111",
    papier: "#FFFFFF",
    texte: "#333333",
    axe: "#000000",
};
const TICKNESS = {
    axe: 1,
    lignes: 1,
};

class Draw extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
        };
        this.parameters = {};
    }
    whitePaper() {
        const ctx = this.refs.canvas.getContext("2d");
        const { width, height } = this.state;

        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = COLORS.papier;
        ctx.fillRect(0, 0, width, height);
        ctx.fillStyle = COLORS.texte;
        ctx.font = "14px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";
        ctx.fillText("www.micetf.fr", width / 2, height);
    }
    drawAxis() {
        const ctx = this.refs.canvas.getContext("2d");
        const { x0, x1, y0, y1 } = this.parameters.axe;
        ctx.lineWidth = TICKNESS.axe;
        ctx.strokeStyle = COLORS.axe;
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
        ctx.closePath();
        ctx.stroke();
    }
    drawGrid({ row, col }) {
        const ctx = this.refs.canvas.getContext("2d");
        const { gap, modele, reprod } = this.parameters;

        ctx.lineWidth = TICKNESS.lignes;
        ctx.strokeStyle = COLORS.lignes;
        for (let r = 0; r < row; r++) {
            for (let c = 0; c < col; c++) {
                ctx.strokeRect(
                    modele.x + c * gap,
                    modele.y + r * gap,
                    gap,
                    gap
                );
                ctx.strokeRect(
                    reprod.x + c * gap,
                    reprod.y + r * gap,
                    gap,
                    gap
                );
            }
        }
    }
    drawSquare(square, gap, { x, y }) {
        const row = square[0] - 1;
        const col = square[1] - 1;
        const color = square[2];
        const ctx = this.refs.canvas.getContext("2d");

        ctx.lineWidth = TICKNESS.lignes;
        ctx.strokeStyle = COLORS.lignes;
        ctx.fillStyle = color;
        ctx.fillRect(x + col * gap, y + row * gap, gap, gap);
        ctx.strokeRect(x + col * gap, y + row * gap, gap, gap);
    }
    drawModele({ squares }) {
        const { gap, modele } = this.parameters;
        squares.forEach(square => this.drawSquare(square, gap, modele));
    }
    drawCopie(squares) {
        const { gap, reprod } = this.parameters;
        squares.forEach(square => this.drawSquare(square, gap, reprod));
    }
    estimateGridSize() {
        const { width, height } = this.state;
        switch (this.props.selectedPosition) {
            case LEFT:
                return {
                    width: Math.floor(width / 2) - 15,
                    height: height - 30,
                };
            case RIGHT:
                return {
                    width: Math.floor(width / 2) - 15,
                    height: height - 30,
                };
            case UP:
                return {
                    width: width - 30,
                    height: Math.floor(height / 2) - 15,
                };
            case DOWN:
                return {
                    width: width - 30,
                    height: Math.floor(height / 2) - 15,
                };
        }
    }
    calculateCoordinates(wGrid, hGrid) {
        const { selectedPosition } = this.props;
        const { width, height } = this.state;

        const axe = _ => {
            switch (selectedPosition) {
                case LEFT:
                case RIGHT:
                    return {
                        x0: Math.round(width / 2),
                        y0: 5,
                        x1: Math.round(width / 2),
                        y1: height - 15,
                    };
                case UP:
                case DOWN:
                    return {
                        x0: 5,
                        y0: Math.round(height / 2),
                        x1: width - 5,
                        y1: Math.round(height / 2),
                    };
            }
        };
        const margeX = Math.round((width / 2 - wGrid) / 2);
        const margeY = Math.round((height / 2 - hGrid) / 2);
        switch (selectedPosition) {
            case LEFT:
                return {
                    modele: {
                        x: margeX,
                        y: Math.round((height - hGrid) / 2),
                    },
                    reprod: {
                        x: Math.round(width / 2) + margeX,
                        y: Math.round((height - hGrid) / 2),
                    },
                    axe: axe(),
                };
            case RIGHT:
                return {
                    modele: {
                        x: Math.round(width / 2) + margeX,
                        y: Math.round((height - hGrid) / 2),
                    },
                    reprod: {
                        x: margeX,
                        y: Math.round((height - hGrid) / 2),
                    },
                    axe: axe(),
                };
            case UP:
                return {
                    modele: {
                        x: Math.round((width - wGrid) / 2),
                        y: margeY,
                    },
                    reprod: {
                        x: Math.round((width - wGrid) / 2),
                        y: Math.round(height / 2) + margeY,
                    },
                    axe: axe(),
                };
            case DOWN:
                return {
                    modele: {
                        x: Math.round((width - wGrid) / 2),
                        y: Math.round(height / 2) + margeY,
                    },
                    reprod: {
                        x: Math.round((width - wGrid) / 2),
                        y: margeY,
                    },
                    axe: axe(),
                };
        }
    }
    gridParameters() {
        const { row, col } = this.props.activeModele;
        const { width, height } = this.estimateGridSize();
        const cellSize = Math.floor(Math.min(height / row, width / col));
        return {
            gap: cellSize,
            width: cellSize * col,
            height: cellSize * row,
            ...this.calculateCoordinates(cellSize * col, cellSize * row),
        };
    }
    update() {
        const { selectedPosition, activeModele, coloredSquares } = this.props;

        this.parameters = this.gridParameters();
        this.whitePaper();

        this.drawGrid(activeModele);
        this.drawAxis();
        this.drawModele(activeModele);
        this.drawCopie(coloredSquares);

        const canvas = this.refs.canvas;
        const ctx = canvas.getContext("2d");
        const { width, height, modele, reprod, gap } = this.parameters;
        this.props.storeCanvas(canvas);
    }
    updateSizes() {
        const canvas = this.refs.canvas;
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        this.setState({
            width: canvas.width,
            height: canvas.height,
        });
    }
    componentDidMount() {
        this.updateSizes();
        window.addEventListener("resize", this.updateSizes.bind(this));
    }
    componentDidUpdate() {
        this.update();
    }
    onCanvasHover(e) {
        const { canvas } = this.refs;
        const x = e.pageX - canvas.offsetLeft;
        const y = e.pageY - canvas.offsetTop;
        const { modele, reprod, width, height } = this.parameters;
        const setCurseur = (zone, curseur) => {
            if (
                y > zone.y &&
                y < zone.y + height &&
                x > zone.x &&
                x < zone.x + width
            ) {
                canvas.classList.add(curseur);
            } else {
                canvas.classList.remove(curseur);
            }
        };
        setCurseur(modele, "crosshair");
        setCurseur(reprod, "pointeur");
    }
    onCanvasClick(e) {
        const { canvas } = this.refs;
        e.preventDefault();

        const obj = e.changedTouches ? e.changedTouches[0] : e.nativeEvent;
        const x = obj.pageX - canvas.offsetLeft;
        const y = obj.pageY - canvas.offsetTop;
        const { reprod, modele, width, height, gap } = this.parameters;
        const { row, col } = this.props.activeModele;

        const whichColor = ({ row, col }) =>
            this.props.activeModele.squares.reduce(
                (color, [rowSquare, colSquare, colorSquare]) => {
                    if (colSquare === col && rowSquare === row) {
                        return colorSquare;
                    }
                    return color;
                },
                "#FFFFFF"
            );
        const computedCoord = side => ({
            row: Math.floor((y - side.y) / gap) + 1,
            col: Math.floor((x - side.x) / gap) + 1,
        });

        const computed = {
            modele: computedCoord(modele),
            reprod: computedCoord(reprod),
        };
        if (
            computed.modele.row > 0 &&
            computed.modele.row <= row &&
            computed.modele.col > 0 &&
            computed.modele.col <= col
        ) {
            this.props.selectColor(whichColor(computed.modele));
        }

        if (
            computed.reprod.row > 0 &&
            computed.reprod.row <= row &&
            computed.reprod.col > 0 &&
            computed.reprod.col <= col
        ) {
            this.props.colorSquare(computed.reprod, this.props.selectedColor);
        }
    }
    render() {
        return (
            <div id="dessin">
                <canvas
                    ref="canvas"
                    onClick={this.onCanvasClick.bind(this)}
                    onTouchEnd={this.onCanvasClick.bind(this)}
                    onMouseMove={this.onCanvasHover.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = ({
    activeModele,
    selectedColor,
    coloredSquares,
    selectedPosition,
}) => {
    return { activeModele, selectedColor, coloredSquares, selectedPosition };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        { selectColor, colorSquare, storeCanvas },
        dispatch
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(Draw);
